import * as React from "react";
import {Dialog, DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {
    DynamicDialog, DynamicDialogProps, DynamicDialogState
} from "shared/controls/Dialogs/core/DynamicDialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import {library} from "@fortawesome/fontawesome-svg-core";
import {Accordion} from "shared/controls/Accordion/Accordion";
import {AccordionItem} from "shared/controls/Accordion/AccordionItem";
import {CollapsiblePanel} from "shared/controls/Containers/CollapsiblePanel";

library.add(faQuestionCircle)

export class FAQDialog extends DynamicDialog<FAQDialogProps,FAQDialogState>{
    static defaultProps: Partial<FAQDialogProps> = {};

    constructor(props: FAQDialogProps) {
        super(props);
        this.state={
            IsOpen:true
        }
    }


    SubRenderer(): React.ReactNode {
        return(
            <Accordion>
                <AccordionItem Title={'How can i do calculations?'}>
                    <p>Most of the fields have a calculator icon, you can add a calculation there.</p>
                    <video style={{border:'#dfdfdf solid 1px'}} src={'http://smartforms.rednao.com/videos/faq/Calculation1.mp4'} autoPlay={true} loop={true} controls={true}/>
                    <p>You can create your own arithmetical operations like multiplying fields (like in the video above).</p>
                    <p>For more information, <a target={'_blank'} href={'https://sfmanual.rednao.com/doc/calculated-fields'}> please check the documentation.</a></p>
                </AccordionItem>
                <AccordionItem Title={'I want to hide a field conditionally'}>
                    <div>
                        <p>For this you can use conditional logic</p>
                        <video style={{border:'#dfdfdf solid 1px'}} src={'http://smartforms.rednao.com/videos/faq/Conditions.mp4'} autoPlay={true} loop={true} controls={true}/>
                        <p>The video above would show the field 'Address' only when the 'Delivery Method' is 'Deliver to my house'</p>
                        <p>For more information, <a target={'_blank'} href={'https://sfmanual.rednao.com/documentation/conditional-logic/showhide-fields/'}> please check the documentation.</a></p>
                    </div>
                </AccordionItem>
                <AccordionItem Title={'Where is the documentation?'}>
                    <p>To check the documentation please visit go to <a target={'_blank'} href={'https://sfmanual.rednao.com/'}>https://sfmanual.rednao.com/</a> </p>
                </AccordionItem>
            </Accordion>

        );
    }

    GetAdditionalProperties(): DialogProps|any {
        return {
            Title:'FAQ',
            ContentStyles:{padding:0},
            Styles:{width:'80%',maxWidth:800},
            Icon:<FontAwesomeIcon style={{fontSize:20}} icon={"question-circle"}/>,
            CancelTitle:'Close'
        }
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FAQDialogProps extends DynamicDialogProps{

}

interface FAQDialogState extends DynamicDialogState{

}

//#endregion "My Region"